// extracted by mini-css-extract-plugin
export default {"ticketNamePrice":"Fx32F","description":"yosro"};